import { FC, useEffect, useState } from 'react';

import { toDataURL } from 'services/api/dataApi';

import './AppIcon.scss';

interface IComponentProps {
  path: string;
  alt?: string;
  className?: string;
}

const AppIcon: FC<IComponentProps> = ({
  path,
  alt = '',
  className = '',
}) => {
  const [avatar, setAvatar] = useState<string | undefined>();

  useEffect(() => {
    if (path) {
      toDataURL(path, setAvatar);
    } else {
      setAvatar('');
    }
  }, [path]);

  return (
    <div className={`image ${className}`}>
      {avatar && <img src={avatar} alt={alt} />}
    </div>
  );
};

export default AppIcon;
